import { Button, Form, Modal, Space, Switch, Table, Tag, Tooltip, message, notification, Avatar, Input, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { TbPlugConnectedX } from "react-icons/tb";
import { useGoogleLogin } from "@react-oauth/google";
import { getUserID } from "../../Utility/service";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { getGoogleAuthCredentials } from "../../api/googleAuthApi";
import { axiosSecureInstance } from "../../api/axios";
import googleDriveIcon from '../../assests/images/knowledge-base-menu/google_drive_icon.svg';
import workBoardIcon from '../../assests/images/knowledge-base-menu/workboard_icon.svg';
import webPageIcon from '../../assests/images/webpageicon.png';
import fireCrawl from '../../assests/images/knowledge-base-menu/fire_crawl_icon.svg';
import flux from '../../assests/images/flux.png';
import hubspot from '../../assests/images/hubspot.jpg';
import activeCollab from '../../assests/images/activeCollab.png';
import LeadsLiftIcon from '../../assests/images/leadslift-logo.png';
import slackLogo from "../../assests/images/slacklogo.png"

import { FileContext } from "../../contexts/FileContext";
import { GET_OR_DELETE_GOOGLE_DRIVE_AUTH_CREDENTIALS, GOOGLE_AUTH_SLUG, GOOGLE_DRIVE_FILES_GETTING_SLUG, REACT_APP_WORKBOARD_AUTH_URL, REACT_APP_WORKBOARD_REDIRECT_URI, SLACK_CONNECTION_STATUS_URL, SLACK_USER_URL, SYNC_GOOGLE_DRIVE_FILES, SYNC_WORKBOARD_ACTION_ITEM, WORKBOARD_AUTH_SLUG, ACTIVE_COLLAB_USER_AUTHENTICATE_URL, ACTIVE_COLLAB_VALIDATE_TOKEN_URL } from "../../constants/Api_constants";
import { useContext } from "react";
import { getWorkBoardAuthCredentials } from "../../api/workBoard";
import { InputModal } from "../common/InputModal";
import { AddWebCrawlKeyFormData } from "./webCrawlForms";
import { deleteFireCrawlKeyFromDB, storeFireCrawlKeyToDB } from "../../api/webCrawl";
import { AddFluxKeyFormData } from "./fluxForms";
import { deleteFluxKeyFromDB, storeFluxKeyToDB } from "../../api/fluxImageGenerator";
import { AddHubspotAccessKeyFormData } from "./hubspotForm";
import { deleteHubspotAccessKeyFromDB, storeHubspotKeyToDB } from "../../api/hubspot";
import { updateUserAcToken } from "../../api/user";

import { MultipleInputFieldModal } from "../common/MultipleInputFieldModal ";
import { AddLeadsLiftKeyFormData } from "./LeadsLiftForm";
import { connectLeadsLift, deleteLeadsLiftKeysFromDB } from "../../api/leadsLift";

import {SlackConnectForm} from "./slackConnectForm";
import {deleteSlackAccessKeyFromDB, storeSlackKeyToDB} from "../../api/slackConnect";
import { deleteBeanstalkCredsFromDB, getConnectionStatus, storeBeanstalkCredsToDB } from "../../api/beanstalk";
import { getAllServices, getService } from "../../api/api_endpoints";
import { BeanstalkModal } from "../common/ApiModal";

import axios from "axios";
import { AddBeanstalkCredsFormData, OauthConnect, validateAndRedirect } from "./beanstalkForm";
const { Title } = Typography;
const userId = getUserID();


export const IntegrateApplications = ({isLoading}) => {
  const [form] = Form.useForm();

  let workboardToken = localStorage.getItem('workboard_access_token') || '';
  let acToken = localStorage.getItem("acToken");

  const {
    isConnected,
    setIsConnected,
    token,
    setToken,
    isWorkBoardConnected,
    setIsWorkBoardConnected,
    workBoardToken,
    setWorkBoardToken,
    isWebCrawlConnected,
    setIsWebCrawlConnected,
    isBeanstalkConnected,
    setIsBeanstalkConnected,
    isFluxConnected,
    setIsFluxConnected,
    isHubspotConnected,
    setIsHubspotConnected,
    isActiveCollabConnected,
    setIsActiveCollabConnected,
    isLeadsLiftConnected, 
    setIsLeadsLiftConnected,
    isSlackConnected,
    setIsSlackConnected,
    setIsLoading
  }=useContext(FileContext);

  const [showSyncFileAlertModal, setShowSyncFileAlertModal] = useState(false);
  const [isWebCrawlerModalOpen,setIsWebCrawlerModalOpen] = useState(false);
  const [isFluxModalOpen,setIsFluxModalOpen] = useState(false);
  const [isHubspotModalOpen,setIsHubspotModalOpen] = useState(false);  
  const [isLeadsLiftModalOpen, setIsLeadsLiftModalOpen] = useState(false);
  const [isActiveCollabModalOpen,setIsActiveCollabModalOpen] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [apiResponse, setApiResponse] = useState([{}]);
  const [formitems, setFormitems] = useState([]);
  const [app, setApp] = useState([]);
  
  const allServices = async () => {
    const services = await getAllServices();
    setApiResponse(services.data.data);
  };
  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    if (email) {
      setUserEmail(email);
    }
  }, []);
    useEffect(() => {
      allServices(); 
    }, []); 
  
    useEffect(() => {
      const fetchConnectionStatuses = async () => {
        if (apiResponse.length === 0) return; 
  
        const appsWithConnection = await Promise.all(
          apiResponse.map(async (record) => {
            const isConnected = await checkServiceConnection(record._id); 
            return {
              name: record.service_name,
              isConnected,
              connect: (service_id, authType, authFields, authenticateFields, oauthurl, tokenurl, baseurl, type, contentType) =>
                handleBeanstalkConnect(service_id, authType, authFields, authenticateFields, oauthurl, tokenurl, baseurl, type, contentType),
              disconnect: (service_id, authType) => handleBeanstalkDisconnect(service_id, authType),
            };
          })
        );
  
        setApp([...staticapps, ...appsWithConnection]); 
      };
  
      fetchConnectionStatuses();
    }, [apiResponse]); 
  
  useEffect(() => {
    const checkAcTokenValidity = async () => {
      if (acToken) {
        try {
          const body = { acToken: acToken };
          const response = await axiosSecureInstance.post(ACTIVE_COLLAB_VALIDATE_TOKEN_URL,body);

          if (response.status === 200 && response.data.status === 'success') {
            setIsActiveCollabConnected(true);
          } else {
            setIsActiveCollabConnected(false);
            message.error(response.data.message);
          }
        } catch (error) {
          setIsActiveCollabConnected(false);
        }
      }
    };

    checkAcTokenValidity();
  }, [acToken]);

  const [isVerified, setIsVerified] = useState(false);
  const [isSlackModalOpen, setIsSlackModalOpen] = useState(false);
  const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [isBeanstalkModalOpen,setIsBeanstalkModalOpen] = useState(false);
  const [serviceid, setServiceId] = useState('');
  const [applicationsData, setApplicationsData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentAppName, setCurrentAppName] = useState("");
  const [currentFields, setCurrentFields] = useState([]);
  const [appConfig, setAppConfig] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [selectedApp, setSelectedApp] = useState(null);

  useEffect(()=>{
    if(workboardToken){
      setWorkBoardToken(workboardToken);
    }

  },[workboardToken]);

  useEffect(() => {
    getGoogleAuthCredentials(userId, setIsConnected, setToken,setIsLoading);
    getWorkBoardAuthCredentials(
      userId,
      setIsWorkBoardConnected,
      setWorkBoardToken
    );
    allServices();
  }, []);

  useEffect(() => {
      const fetchApps = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/get-apps`);
          const apps = response.data.apps.map((app) => ({
            key: app._id,
            name: app.service_name,
            slug: app.slug,
            status: app.is_active ? 'Connected' : 'Disconnected',
            icon: (
              <img
                src={app.service_icon} 
                alt={`${app.service_name} Icon`}
                style={{ width: 25, height: 25, marginRight: 9, marginLeft: 0, alignItems: 'left' }}
              />
            ),
            isConnected: app.is_active, 
            // connect: () => handleConnect(app.slug), // Define connection logic
            // disconnect: () => handleDisconnect(app.slug), // Define disconnection logic
          }));
          setApplicationsData(apps);
        } catch (error) {
          console.error('Error fetching apps:', error);
        }
      };
  
      fetchApps();
    }, []);

  useEffect(() => {
    const checkSlackConnection = async () => {
      const storedMemberId = localStorage.getItem('memberId'); 
      if (!storedMemberId) {
        return;
       } 
      try {
        const response = await fetch(`${SLACK_CONNECTION_STATUS_URL}?memberId=${storedMemberId}`);
        const data = await response.json();

        if (data.connected) {
          setIsSlackConnected(true);
        }
      } catch (error) {
        console.error('Error fetching Slack connection status:', error);
      }
    };

    checkSlackConnection();
  }, []);

  useEffect(() => {
    if (token) {
      fetch(GOOGLE_DRIVE_FILES_GETTING_SLUG, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .catch((error) => console.error('Error fetching files:', error));
    }
  }, [token]);



    


  const handleOpenModal = async (appId) => {
      if (!appId) {
        console.error('appId is undefined');
        return;
      }
      try {
        // Fetch the app configuration using the slug as the identifier
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/config/${appId}`);
        const appConfigFromDB = response.data;
  
        if (!appConfigFromDB) {
          console.error('No app configuration found');
          message.error('No app configuration found.');
          return;
        }
  
        // Set the fetched app configuration to state
        setAppConfig({
          _id: appConfigFromDB._id,
          name: appConfigFromDB.service_name,
          slug: appConfigFromDB.slug,
          icon: appConfigFromDB.service_icon,
          customFields: appConfigFromDB.customFields || [],
        });
  
        // Prepare initial form data for the custom fields
        const initialFormData = (appConfigFromDB.customFields || []).reduce((acc, field) => {
          acc[field.name] = ''; // Initialize each field with an empty value
          return acc;
        }, {});
        setFormData(initialFormData);
  
        // Open the modal
        setIsModalVisible(true);
      } catch (error) {
        console.error('Error fetching app configuration:', error);
        message.error('Failed to fetch app configuration.');
      }
    };
  const handleConnectClick = (app) => {
    setCurrentAppName(app.name);
    setCurrentFields(app.fields || []);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalVisible(false); // Hide the modal
    setSelectedApp(null); // Clear the selected app
  };

  const handleFormSubmit = async (values) => {
      const userID = getUserID()
      const { appId, appName, slug = appId, ...credentials } = values; // Default slug to appId if not provided
  
      try {
        // Save credentials with slug
        const saveResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}api/user-creds/save-creds`, {
          appId,
          appSlug: slug, // Pass slug as appSlug
          credentials,
          userId: userID,
        });
  
  
        const updateResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}api/user-creds/update-connection-status`, {
          appId,
          isConnected: true,
        });
        // Update application data in UI
        setApplicationsData((prevData) =>
          prevData.map((item) =>
            item.key === appId ? { ...item, status: "Connected" } : item
          )
        );
  
        setIsModalVisible(false);
      } catch (error) {
        console.error('Error in handleFormSubmit:', {
          message: error.message,
          response: error.response?.data,
          stack: error.stack,
        });
        alert(error.response?.data?.error || 'Error saving credentials');
      }
    };

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const body = { userId, code: codeResponse.code };
      const response = await axiosSecureInstance.post(GOOGLE_AUTH_SLUG, body);
      const accessToken = response?.data?.token;
      setToken(accessToken);
      setIsConnected(true);
    },
    flow: 'auth-code',
    scope: [
      'profile',
      'email',
      'https://www.googleapis.com/auth/drive.readonly',
      'https://www.googleapis.com/auth/drive.file',
      'https://www.googleapis.com/auth/drive.metadata.readonly',
      'https://www.googleapis.com/auth/drive',
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/userinfo.email',
    ].join(' '),
    prompt: 'consent',
  });

  const logout = async () => {
    await axiosSecureInstance.delete(GET_OR_DELETE_GOOGLE_DRIVE_AUTH_CREDENTIALS(userId));
    setIsConnected(false);
  };
  const syncWorkBoardActionItem = async () => {
    setIsLoading(true);
    try {
      const startTime = Date.now();
      const response = await axiosSecureInstance.get(SYNC_WORKBOARD_ACTION_ITEM(userId));
      const endTime = Date.now();

      const timeTaken = endTime - startTime;

      notification.open({
        message: 'Work Board Action Item Synced',
        description: 'All personal and assigned action items are synced successfully.',
        placement: 'bottomRight',
        style: {
          backgroundColor: '#6697cc',
          border: '1px solid #6697cc',
        },
      });
    } catch (error) {
      console.error("Error syncing WorkBoard:", error);
      notification.open({
        message: 'Sync Failed',
        description: 'Failed to sync WorkBoard Action Items. Please try again later.',
        placement: 'bottomRight',
        style: {
          backgroundColor: '#ff4d4f',
          border: '1px solid #ff4d4f',
        },
      });
    } finally {
      setIsLoading(false);
    }

  };

  const syncGoogleDriveFiles = async () => {
    const response = await axiosSecureInstance.get(SYNC_GOOGLE_DRIVE_FILES(userId));
    notification.open({
      message: 'Google Drive Files Synced',
      description: `Total ${response.data.allDownloadedFileList.length} Files Are Synced.`,
      placement: 'bottomRight',
      style: {
        backgroundColor: '#6697cc',
        border: '1px solid #6697cc',
      },
    });
  };

  const handleConnectWorkBoard = () => {
    const clientId = process.env.REACT_APP_WORKBOARD_CLIENT_ID;
    const redirectUri = REACT_APP_WORKBOARD_REDIRECT_URI;
    const authorizationUrl = `${REACT_APP_WORKBOARD_AUTH_URL}?client_id=${clientId}&redirect_uri=${redirectUri}`;
    window.location.href = authorizationUrl;
  };

  const handleRemoveWorkBoard = async () => {
    Modal.confirm({
      title: 'Confirm Disconnection',
      content: 'Are you sure you want to disconnect your WorkBoard account?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        localStorage.removeItem('workboard_access_token');
        const response = await axiosSecureInstance.delete(WORKBOARD_AUTH_SLUG(userId));
        setIsWorkBoardConnected(false);
        setWorkBoardToken('');
        message.success(response.data.message);
      },
    });
  };

  const handleSlackDisconnect = async()=>{
    const responseOfSlackKeyDelete = await deleteSlackAccessKeyFromDB();
    if(responseOfSlackKeyDelete.status === 200){
      setIsSlackConnected(false);
      localStorage.removeItem('memberId');
      localStorage.removeItem('oauthToken');
      message.success(responseOfSlackKeyDelete.data.message);
    }else{
      message.error(responseOfSlackKeyDelete.data.message);
    }
    return responseOfSlackKeyDelete;
  };

  const handleSlackConnect = () => {
    setIsSlackModalOpen(true);
  }

  const handleWebCrawlConnect =()=>{
    setIsWebCrawlerModalOpen(true);

  };
  const handleFluxConnect =()=>{
    setIsFluxModalOpen(true);

  };

  const handleWebCrawlDisConnect = async()=>{
    const responseOfFireCrawlKeyDelete = await deleteFireCrawlKeyFromDB();
    if(responseOfFireCrawlKeyDelete.status === 200){
      setIsWebCrawlConnected(false);
      message.success(responseOfFireCrawlKeyDelete.data.message);
    }else{
      message.error(responseOfFireCrawlKeyDelete.data.message);
    }
    return responseOfFireCrawlKeyDelete;
  };

  const handleFluxDisConnect = async()=>{
    const responseOfFluxKeyDelete = await deleteFluxKeyFromDB();
    if(responseOfFluxKeyDelete.status === 200){
      setIsFluxConnected(false);
      message.success(responseOfFluxKeyDelete.data.message);
    }else{
      message.error(responseOfFluxKeyDelete.data.message);
    }
    return responseOfFluxKeyDelete;
  };

  const handleBeanstalkConnect = async (service_id, authType, authFields, authenticateFields, oauthurl, tokenurl, baseurl, type, contentType) => {
    setServiceId(service_id);
    if(authType == 'OAuth'){  
    const response = await OauthConnect(service_id, authFields, authenticateFields, oauthurl, tokenurl, baseurl, type, contentType);
    const { authorizationUrl } = response;
     const validation = await validateAndRedirect(authorizationUrl);
     
     if(typeof validation.data === 'object' && validation.data.status === false ){
       message.error('Technical Issue, contact your Administrator');
      }else {
       window.location.href = authorizationUrl;
     }
    }
    else{
      const items = await AddBeanstalkCredsFormData(service_id);
      setFormitems(items);
      setIsBeanstalkModalOpen(true);
    }
  }

  const handleBeanstalkDisconnect = async(service_id) => {
    const responseOfBeanstalkCredsDelete = await deleteBeanstalkCredsFromDB(service_id);
    if(responseOfBeanstalkCredsDelete.status === 200){
      setIsBeanstalkConnected(false);
      message.success(responseOfBeanstalkCredsDelete.data.message);
       allServices();
    }else{
      message.error(responseOfBeanstalkCredsDelete.data.message);
    }
    return responseOfBeanstalkCredsDelete;
  }

  const handleHubspotConnect =()=>{
    setIsHubspotModalOpen(true);
  };

  const handleHubspotInputModalClose = ()=>{
    setIsHubspotModalOpen(false);
  }

  const handleHubspotKeyInsert = async () => {
    form
      .validateFields()
      .then(async (values) => {
        const responseOfKeyStore = await storeHubspotKeyToDB(values?.hubspotAccessToken);
        setIsHubspotConnected(true);
        setIsHubspotModalOpen(false);
        message.success(responseOfKeyStore.data.message);
        form.resetFields();
      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });
  };

  const handleHubspotDisConnect = async()=>{
    const responseOfHubspotKeyDelete = await deleteHubspotAccessKeyFromDB();
    if(responseOfHubspotKeyDelete.status === 200){
      setIsHubspotConnected(false);
      message.success(responseOfHubspotKeyDelete.data.message);
    }else{
      message.error(responseOfHubspotKeyDelete.data.message);
    }
    return responseOfHubspotKeyDelete;
  };

  const handleConnectActiveCollab = async () => {
    form.setFieldsValue({ email: userEmail });
    setIsActiveCollabModalOpen(true);    
  };

  const handleActiveCollabDisConnect = async()=>{
    let userTokenDetails = { userAcToken: ""};
    const removeUserAcToken = await updateUserAcToken(userId, userTokenDetails);
    if(removeUserAcToken.status === 200){
      localStorage.setItem("isActiveCollabConnected", "false");
      localStorage.setItem("acUserDetails", "");
      localStorage.setItem("acToken", "");
      setIsActiveCollabConnected(false);
      message.success(removeUserAcToken.data.message);
    }else{
      message.error(removeUserAcToken.data.message);
    }
    return removeUserAcToken;
  };

  const handleActiveCollabSubmit = async () => {
    try {
      // Validate the form fields
      const values = await form.validateFields();
      const updatedValues = { ...values, userEmail: userEmail };

      // Make the API call using axiosSecureInstance
      const response = await axiosSecureInstance.post(ACTIVE_COLLAB_USER_AUTHENTICATE_URL, updatedValues);

      if (response.data.status === "success") {
        message.success(response.data.message);
        let acUserDetails = JSON.stringify(response.data.acUserDetails);
        setIsActiveCollabConnected(true);
        localStorage.setItem("isActiveCollabConnected", "true");
        localStorage.setItem("acUserDetails", acUserDetails);
        localStorage.setItem('acToken', response.data.acToken);
        let userTokenDetails = { userAcToken: response.data.acToken};
        const updatedUserAcToken = await updateUserAcToken(userId, userTokenDetails);
        setIsActiveCollabModalOpen(false); // Close the modal
        form.resetFields();
      } else {
        // Handle unexpected status codes
        setIsActiveCollabConnected(false);
        message.error(response.data.message);
      }
    } catch (error) {
      message.error(error.response.data.message);
    }
  };

  const handleActiveCollabModalCancel = () => {
    setIsActiveCollabModalOpen(false); // Close the modal without submitting
  };

  const handleLeadsLiftConnect = () => {
    setIsLeadsLiftModalOpen(true);
  };

  const handleLeadsLiftKeysInsert = async () => {
    try {
      const values = await form.validateFields();
      const response = await connectLeadsLift(values.leadsLiftToken, values.leadsLiftLocationId, values.leadsLiftUserId);
      if (response?.data) {
        setIsLeadsLiftConnected(true);
        setIsLeadsLiftModalOpen(false);
        message.success(response.message);
            form.resetFields();
    } else {
        message.error(response.message);
    }
    } catch (validationError) {
      console.log("Validation failed:", validationError);
    }
  };

  // Define checkServiceConnection function
  const checkServiceConnection = async (service_id) => {
    const status = await getConnectionStatus(service_id); 
    return status;
  };

  const handleLeadsLiftDisConnect = () => {
    Modal.confirm({
      title: "Confirm Disconnection",
      content: "Are you sure you want to disconnect LeadsLift?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          const { success, error } = await deleteLeadsLiftKeysFromDB();
          if (success) {
            setIsLeadsLiftConnected(false);
            message.success(success);
    } else {
            message.error(error);
          }
    } catch (error) {
          console.error("Error disconnecting LeadsLift:", error);
          message.error("Failed to disconnect LeadsLift");
      }
      },
    });
  };

  const iconStyle = { width: 25, height: 25, marginRight: 9, marginLeft: 15 };

  const applicationData = [
  { key: '1', name: 'Google Drive', icon: <img src={googleDriveIcon} alt="Google Drive Icon" style={iconStyle} /> },
  { key: '3', name: 'Firecrawl', icon: <img src={fireCrawl} alt="WebCrawl Icon" style={iconStyle} /> },
  { key: '4', name: 'Flux', icon: <img src={flux} alt="Flux Icon" style={iconStyle} /> },
  { key: '5', name: 'Hubspot', icon: <img src={hubspot} alt="Hubspot Icon" style={iconStyle} /> },
  { key: '2', name: 'Work Board', icon: <img src={workBoardIcon} alt="WorkBoard Icon" style={iconStyle} /> },
  { key: '8', name: 'Slack', icon: <img src={slackLogo} alt="Slack Icon" style={iconStyle} /> },
  { key: '6', name: 'LeadsLift', icon: <img src={LeadsLiftIcon} alt="LeadsLift Icon" style={iconStyle} /> },
  { key: '7', name: 'Active Collab', icon: <img src={activeCollab} alt="Active Collab Icon" style={iconStyle} /> },
  ];

const icons = {
  // beanstalk: beanstalk,
  // Add more mappings for slug to icon references as needed
};
const updatedApplicationData = [
  ...applicationData,
  ...apiResponse
    .filter((record) => record.is_active) 
    .map((record) => {
      return {
        key: record._id,
        name: record.service_name,
        service_id: record._id,
        icon: (
          <img
            src={`${process.env.REACT_APP_BASE_URL}${record.service_icon}`} 
            alt={`${record.service_name} Icon`}
            style={iconStyle}
          />
        ),
        authType: record.authType,
        authFields: record.authFields,
        authenticateFields: record.authenticateFields,
        oauthurl: record.oauthurl ?? '',
        tokenurl: record.tokenurl ?? '',
        baseurl: record.baseurl ?? '',
        type: record.type ?? '',
        contentType: record.contentType ?? '',
        is_active: record.is_active,
      };
    }),
];

  const staticapps = [
    {
      name: "Google Drive",
      isConnected: isConnected,
      connect: login,
      disconnect: logout
    },
    {
      name: "Work Board",
      isConnected: workBoardToken,
      connect: handleConnectWorkBoard,
      disconnect: handleRemoveWorkBoard,
      sync: syncWorkBoardActionItem
    },
    {
      name: "Firecrawl",
      isConnected: isWebCrawlConnected,
      connect: handleWebCrawlConnect,
      disconnect: handleWebCrawlDisConnect,
    },
    {
      name: "Flux",
      isConnected: isFluxConnected,
      connect: handleFluxConnect,
      disconnect: handleFluxDisConnect,
    },
    {
      name: "Hubspot",
      isConnected: isHubspotConnected,
      connect: handleHubspotConnect,
      disconnect: handleHubspotDisConnect,
    },
    {
      name: "LeadsLift",
      isConnected: isLeadsLiftConnected,
      connect: handleLeadsLiftConnect,
      disconnect: handleLeadsLiftDisConnect,
    },
    {
      name: "Active Collab",
      isConnected: isActiveCollabConnected,
      connect: handleConnectActiveCollab,
      disconnect: handleActiveCollabDisConnect,
    },
    {
      name: "Slack", 
      isConnected: isSlackConnected,
      connect: handleSlackConnect,
      disconnect: handleSlackDisconnect,
    },
    {
      name: 'Beanstalk',
      isConnected: isBeanstalkConnected,
      connect: (service_id) => handleBeanstalkConnect(service_id),
      disconnect: (service_id) => handleBeanstalkDisconnect(service_id),
    },
  ];
  const apps = [
    ...staticapps,
    ...app
  ]

  const columns = [
    {
      title: 'Application',
      dataIndex: 'name',
      key: 'name',
      align: 'start',
      render: (text, record) => (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', fontSize: '16px' }}>
          {record.icon}
          <b>{text}</b>
        </span>
      ),
    },

    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (_, record) => {
        const app = apps.find(app => app.name === record.name) || applicationsData.find(app => app.name === record.name);
        
        return app ? (
          <Space>
            <Tag color={app.isConnected ? 'green' : 'red'}>
              {app.isConnected ? 'Connected' : 'Disconnected'}
            </Tag>
          </Space>
        ) : null;
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "left",
      render: (_, record) => {
        const app = apps.find(app => app.name === record.name); // Find matching app
    
        if (app) {
          return (
            <Space>
              {app.isConnected ? (
                <Space>
                  <Tooltip title={`Disconnect from ${app.name}`}>
                    <Button
                      onClick={() => record.service_id ? app.disconnect(record.service_id) : app.disconnect()}
                      style={{ backgroundColor: "#6697cc" }}
                    >
                      Disconnect
                    </Button>
                  </Tooltip>
                  {app.sync && (
                    <Tooltip title={`Sync ${app.name}`}>
                      <Button onClick={app.sync} style={{ backgroundColor: "#6697cc"}}>
                        Sync
                      </Button>
                    </Tooltip>
                  )}
                </Space>
              ) : (
                <Tooltip title={`Connect to ${app.name}`}>
                  <Button onClick={() => record.service_id ? app.connect(record.service_id, record.authType,record.authFields,record.authenticateFields,record.oauthurl,record.tokenurl, record.baseurl, record.type, record.contentType) : app.connect()}>
                    Connect
                  </Button>
                </Tooltip>
              )}
            </Space>
          );
        }

        return (
          <Space>
            <Tooltip
              title={
                record.status === 'Connected'
                  ? `Disconnect from ${record.name}`
                  : `Connect to ${record.name}`
              }
            >
              <Button
                onClick={() => {
                  if (record.status === 'Connected') {
                    setApplicationsData(prevData =>
                      prevData.map(item =>
                        item.key === record.key
                          ? { ...item, status: 'Disconnected' }
                          : item
                      )
                    );
                  } else {
                    handleConnectClick(record);
                    handleOpenModal(record.slug);
                  }
                }}
              >
                {record.status === 'Connected' ? 'Disconnect' : 'Connect'}
              </Button>
            </Tooltip>
          </Space>
        );
      },
    }
  ];
  const handleWebCrawlKeyInsert = async () => {
    form
      .validateFields()
      .then(async (values) => {
        const responseOfKeyStore = await storeFireCrawlKeyToDB(values?.fireCrawlKey);
        setIsWebCrawlConnected(true);
        setIsWebCrawlerModalOpen(false);
        message.success(responseOfKeyStore.data.message);
        form.resetFields();

      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });

  };
  const handleBeanstalkInstertCreds = async (formItems) => {
    
    form
      .validateFields()
      .then(async (values) => {

        const groupedValues = {
          authFields: {},
          headers: {},
          otherFields: {},
        };

        formItems.forEach((item) => {
          if (item.group === 'authFields') {
            groupedValues.authFields[item.name] = values[item.name];
          } else if (item.group === 'headers') {
            groupedValues.headers[item.name] = values[item.name];
          } else {
            groupedValues.otherFields[item.name] = values[item.name];
          }});
          
        const responseOfKeyStore = await storeBeanstalkCredsToDB(groupedValues,serviceid);
        setIsBeanstalkConnected(true);
        setIsBeanstalkModalOpen(false);
        message.success(responseOfKeyStore.data.message);
        allServices();
        form.resetFields();

      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });

  };
  const handleFluxKeyInsert = async () => {
    form
      .validateFields()
      .then(async (values) => {
        const responseOfKeyStore = await storeFluxKeyToDB(values?.fluxKey);
        setIsFluxConnected(true);
        setIsFluxModalOpen(false);
        message.success(responseOfKeyStore.data.message);
        form.resetFields();

      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });

  };

  const handleFireCrawlModalClose = ()=>{
    setIsWebCrawlerModalOpen(false);
  }
  const handleFluxInputModalClose = ()=>{
    setIsFluxModalOpen(false);
  }

  const handleInputModalClose = () => {
    setIsSlackModalOpen(false);
    setIsBeanstalkModalOpen(false);
  };
 
   const handleSlackKeyInsert = async () => {
     form
         .validateFields()
         .then(async (values) => {
          console.log(values)
             const responseOfKeyStore = await storeSlackKeyToDB(values);
             setIsSlackConnected(true);
             localStorage.setItem('memberId', values.memberId);
             localStorage.setItem('oauthToken', values.oauthToken);
    setIsSlackModalOpen(false);
             message.success(responseOfKeyStore.data.message);
        form.resetFields();
         })
         .catch((errorInfo) => {
             console.log('Validation failed:', errorInfo);
         });
  };
 
  const handleVerifySlackKey = async () => {
     const oauthToken = form.getFieldValue('oauthToken');
     const memberId = form.getFieldValue('memberId');

    if (!oauthToken || !memberId) {
      console.error("OAuth token and Member ID are required.");
      message.error("OAuth token and Member ID are required.");
      return;
    }
    setIsLoading(true);

    try {
      const response = await fetch(
        `${SLACK_USER_URL}?oauthToken=${oauthToken}&memberId=${memberId}`,
         { method: 'GET' }
      );

      const data = await response.json();

      if (data.success) {
         setUserProfile({ realName: data.data.realName, avatar: data.data.avatar });
        setIsVerified(true);
        setIsVerifyModalOpen(true);
        message.success("Slack user verified successfully!");
      } else {
        console.error("Error fetching user info:", data.error);
        message.error(data.error || "Failed to fetch user info.");
      }
    } catch (error) {
      console.error("An error occurred while verifying the Slack user:", error);
       message.error("An unexpected error occurred while verifying the Slack user. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "500px" }}>
      <div className="header-section">
        <h2 className="component-title">Connected Apps</h2>
        <p className="component-subtitle">
          Connect and manage your integrations with external applications and services to enhance your workflow.
        </p>
      </div>
      <Table
        loading={isLoading}
        bordered={true}
        columns={columns}
        dataSource={updatedApplicationData}
        pagination={false}
        rowClassName={(record) => 
          record.name === "Slack" || record.name === "Hubspot" || record.name === "LeadsLift" || record.name === "Active Collab" || record.name === "Work Board" ? "gray-out" : ""
        }
      />
      <Modal
        title={
          <>
            <ExclamationCircleOutlined
              style={{ color: "red", marginRight: 8 }}
            />
            Google Drive File Sync Failed
          </>
        }
        open={showSyncFileAlertModal}
        onOk={() => setShowSyncFileAlertModal(false)}
        onCancel={() => setShowSyncFileAlertModal(false)}
      >
        <p>Please Connect With Google Drive</p>
      </Modal>

      <Modal
        title="Connect to Active Collab"
        open={isActiveCollabModalOpen}
        onOk={handleActiveCollabSubmit}
        onCancel={handleActiveCollabModalCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input placeholder="Enter your email" disabled/>
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter your password!" }]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>
        </Form>
      </Modal>

      <InputModal
        propsData={{
          title: "Add FireCrawl Key",
          data: null,
          placeholder: "Add FireCrawl Key",
          open: isWebCrawlerModalOpen,
          onCancel: handleFireCrawlModalClose,
          onOk: handleWebCrawlKeyInsert,
          okText: "Add Key",
          formItems: AddWebCrawlKeyFormData,
          form: form,
        }}
      />
      <InputModal
        propsData={{
          title: "Add Flux Key",
          data: null,
          placeholder: "Add Flux Key",
          open: isFluxModalOpen,
          onCancel: handleFluxInputModalClose,
          onOk: handleFluxKeyInsert,
          okText: "Add Key",
          formItems: AddFluxKeyFormData,
          form: form,
        }}
      />

      <InputModal
        propsData={{
          title: "Add Hubspot Access Key",
          data: null,
          placeholder: "Add Hubspot Access Key",
          open: isHubspotModalOpen,
          onCancel: handleHubspotInputModalClose,
          onOk: handleHubspotKeyInsert,
          okText: "Add Key",
          formItems: AddHubspotAccessKeyFormData,
          form: form
        }}
      />

      <InputModal
        propsData={{
        title: "Add Slack Integration",
          data: null,
        placeholder: "Enter Slack Details",
          open: isSlackModalOpen,
          onCancel: handleInputModalClose,
          onOk: handleSlackKeyInsert,
          okText: "Add Slack",
          formItems: SlackConnectForm,
          form: form,
          onVerify: handleVerifySlackKey,
        integration: "slack"
        }}
        />

      <Modal
        title="Verify Slack User"
        visible={isVerifyModalOpen}
        onCancel={() => setIsVerifyModalOpen(false)}
        footer={[
          <Button key="close" onClick={() => setIsVerifyModalOpen(false)}>
            Close
          </Button>,
        ]}
      >
        {userProfile && (
          <div style={{ textAlign: 'center' }}>
            <Avatar src={userProfile.avatar} size={100} />
            <h3>{userProfile.realName}</h3>
          </div>
        )}
      </Modal>

      <MultipleInputFieldModal
        propsData={{
          title: "Add LeadsLift Credentials",
          data: null,
          open: isLeadsLiftModalOpen,
          onCancel: () => setIsLeadsLiftModalOpen(false),
          onOk: handleLeadsLiftKeysInsert,
          okText: "Connect",
          formItems: AddLeadsLiftKeyFormData,
          form: form,
        }}
      />

      <BeanstalkModal
        propsData={{
          title: "Required Fields to Connect the Service",
          data: null,
          placeholder: "",
          open: isBeanstalkModalOpen,
          onCancel: handleInputModalClose,
          onOk: handleBeanstalkInstertCreds,
          okText: "Add",
          formItems: Array.isArray(formitems) ? formitems : [],
          form: form
        }}
      />

      <Modal
        title={`Configure ${appConfig?.name}`}
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        {appConfig && (
          <Form
            onFinish={handleFormSubmit}
            initialValues={{ appId: appConfig._id, appName: appConfig.name, slug: appConfig.slug }} // Add slug
          >
            <Row gutter={16}>
              <Col span={24} style={{ textAlign: 'center' }}>
                <img src={appConfig.iconUrl} alt={appConfig.name} width={50} height={50} />
                <h3>{appConfig.name}</h3>
              </Col>
            </Row>

            <Form.Item name="appId" hidden>
              <Input />
            </Form.Item>

            <Form.Item name="appName" hidden>
              <Input />
            </Form.Item>

            <Form.Item name="slug" hidden>
              <Input />
            </Form.Item>

            {appConfig.customFields.map((field) => (
              <Form.Item
                key={field.name}
                label={field.label}
                name={field.name}
                rules={[{ required: true, message: `${field.label} is required` }]}
              >
                <Input />
              </Form.Item>
            ))}

            <Space style={{ width: '100%', justifyContent: 'center' }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Space>
          </Form>
        )}

      </Modal>
    </div>
  );
};

export default IntegrateApplications;